@if (messageListPinned().length) {
  <div class="task-view-comments__comment-items">
    @for (message of messageListPinned(); track trackByMessageId($index, message)) {
      <app-task-view-comment-item
        class="task-view-comments__comment task-view-comment-item_pinned"
        [message]="message"
      ></app-task-view-comment-item>
    }
  </div>
}

@if (messageListHide().length) {
  @switch (isShowMoreMessage()) {
    @case (false) {
      <div class="task-view-comments__more-message">
        <span (click)="showMoreMessage()">Остальные {{ messageListHide().length }} сообщений</span>
      </div>
    }
    @case (true) {
      <div class="task-view-comments__more-message"><span (click)="hideMoreMessage()">Свернуть сообщения</span></div>
    }
  }
}

@if (isShowMoreMessage()) {
  <div class="task-view-comments__comment-items">
    @for (message of messageListHide(); track trackByMessageId($index, message); let index = $index) {
      <app-task-view-comment-item
        class="task-view-comments__comment"
        [message]="message"
        [prevUserId]="index > 0 ? messageListHide()[index - 1].authorId : false"
      ></app-task-view-comment-item>
    }
  </div>
}

<div class="task-view-comments__comment-items">
  @for (message of messageList(); track trackByMessageId($index, message); let index = $index) {
    <app-task-view-comment-item
      class="task-view-comments__comment"
      [message]="message"
      [prevUserId]="index > 0 ? messageList()[index - 1].authorId : false"
    ></app-task-view-comment-item>
  }
  <div id="destination"></div>
</div>
